import axios from 'axios';
import authService from '../../services/authService';

export const FETCH_OPTIONS = 'FETCH_OPTIONS';

const fetchOptionsAction = (optionType) => {
    return async (dispatch, getState) => {
        const SERVER_URL = authService.getCaseManagerBasePath();
        const authResponse = await authService.getToken();

        const config = {
            headers: {
                Authorization: `Bearer ${authResponse.data.access_token}`
            }
        };

        const optionQuery = (optionType !== undefined)? `?type=${optionType}` : '';
        const response = await axios.get(`${SERVER_URL}/api/options${optionQuery}`,config);
        dispatch({
            type: FETCH_OPTIONS,
            payload: optionType? response.data.sort((a, b) => (a.order > b.order) ? 1 : -1) : response.data,
            optionType: optionType
        });
    };
};

export default fetchOptionsAction;
